module.exports = __webpack_public_path__ + "img/htcm_09.ae407d8e.jpg";